import { useTranslation } from 'react-i18next'

import HeaderPages from '~/components/HeaderPages'
import PageTitle from '~/components/PageTitle'

import PanelPublisherAdTypes from './PanelPublisherAdTypes'

const AdTypesPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageTitle title={t('rm:config.adTypes.pageTitle')} />

      <HeaderPages title={t('rm:config.adTypes.pageTitle')} />

      <PanelPublisherAdTypes />
    </>
  )
}

export default AdTypesPage
